module.exports = __webpack_public_path__ + "media/src/images/icons/globe-70ed21dbef38bf7a61b8f0a9c14e30ab.svg";